/**
 * Zodiac PDP — keeps "Meet the Stones" on the selected sign's set.
 *
 * Variant selection itself is entirely Impulse's (theme.js reads the picker's
 * radios, updates price/image/URL/add-to-cart). This script only listens to
 * the same radios and shows the matching `[data-zodiac-stones]` group.
 *
 * Loaded only by product-template-zodiac.liquid. No-op on any page without
 * stone groups. Without JS the server-rendered group for the initially
 * selected sign stays visible, so nothing breaks.
 */
(function () {
  function showStonesFor(scope, sign) {
    if (!sign) return;
    var groups = scope.querySelectorAll('[data-zodiac-stones]');
    if (!groups.length) return;
    var matched = false;
    groups.forEach(function (g) {
      var on = g.getAttribute('data-zodiac-stones') === sign;
      if (on) matched = true;
      g.hidden = !on;
    });
    // A sign with no mapped set (should not happen) must never blank the block.
    if (!matched) groups[0].hidden = false;
  }

  function signFromInput(input) {
    if (!input || !input.id) return null;
    var label = input.parentNode && input.parentNode.querySelector('label[data-zodiac-sign]');
    return label ? label.getAttribute('data-zodiac-sign') : null;
  }

  function scopeOf(el) {
    return el.closest('[data-section-type="product"], .shopify-section, .product-section') || document;
  }

  // Delegated, so it keeps working after the theme editor re-renders a section.
  document.addEventListener('change', function (evt) {
    var input = evt.target;
    if (!input || !input.matches || !input.matches('.zodiac-picker--signs input[type="radio"][data-variant-input]')) return;
    if (!input.checked) return;
    showStonesFor(scopeOf(input), signFromInput(input));
  });

  // Sync once on load in case the browser restored a different checked radio
  // (back/forward cache) than the one the server rendered.
  function syncAll() {
    document.querySelectorAll('.zodiac-picker--signs input[type="radio"][data-variant-input]:checked').forEach(function (input) {
      showStonesFor(scopeOf(input), signFromInput(input));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAll);
  } else {
    syncAll();
  }
  window.addEventListener('pageshow', syncAll);
  document.addEventListener('shopify:section:load', syncAll);
})();
